import React, { useState } from "react";

import Quest from "./questions";
import questions from "../questions.json";
import Result from "./result";

const Test = () => {

  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [site, setSite] = useState(false);

  // checking that all answers are selected before giving next page option
  const [answer, setAnswer] = useState(null);

  const handleChoiceSelected = (questionIndex, choice) => {
    console.log(questionIndex, choice);
    setAnswer(choice);
  };

  const allQuestionsAnswered = answer !== null;

  // eslint-disable-next-line
  const [data, setData] = useState([]);

  const updateTally = (num, item) => {
    // console.log(num, item.rating, item.number);
    //console.log(key[item.rating].tally);

    // Create an updated item object with the new "vote" key-value pair
    const updatedItem = {
      ...item,
      vote: num,
    };
    console.log(updatedItem);
    const answerIndex = data.findIndex((item) => item.number === updatedItem.number);
    if (answerIndex < 0) {
      data.push(updatedItem);
    } else {
      data[answerIndex].vote = num;
    }
    console.log(data);

    handleChoiceSelected(item, num);

    if (data.length === questions.Questions.length) {
      setSite(true);
    }
  };

  const handleNextQuestion = () => {
    if (currentQuestion < questions.Questions.length -1 && allQuestionsAnswered) {
      setCurrentQuestion(currentQuestion + 1);
    }

    const answer = data.find(item => item.number === questions.Questions[currentQuestion+1].number);
    setAnswer(answer ? answer.vote : null);
  }

  const handlePreviousQuestion = () => {
    if (currentQuestion <= 0) {
      return false;
    }
    setCurrentQuestion(currentQuestion - 1);
    const answer = data.find(item => item.number === questions.Questions[currentQuestion-1].number);
    setAnswer(answer.vote);
  }

  return (

    <>
      {!site && (
        <div className="test_main">
          <hr></hr>
          <div className="qlist">
            <Quest item={questions.Questions[currentQuestion]} key={0} onVote={updateTally} preSelectedChoice={data.find(item => item.number === questions.Questions[currentQuestion].number)?.vote} />
          </div>
          <div className={"control-btns"}>
            <button className={'btn' + (currentQuestion < 1 ? ' disabled' : '')} onClick={handlePreviousQuestion}>{"< Back"}</button>
            <button className={'btn' + (!allQuestionsAnswered ? ' disabled' : '')} onClick={handleNextQuestion}>{"Next >"}</button>
          </div>
          <div className={"progress-container"}>
            <p>Question { currentQuestion +1 } of { questions.Questions.length}</p>
          </div>
        </div>
      )}
      {site && <Result data={data} />}
    </>
  );
};

export default Test;
